import * as moment from "moment";

export class RecruitMember {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.appUserID = json && json.app_user_id || null;
        this.renewalCount = json && json.renewal_count || 0
        this.inactive = json && json.inactive || false;
        this.firstName = json && json.first_name || null;
        this.lastName = json && json.last_name || null;
        this.email = json && json.email || null;
        this.paymentManager = json && json.payment_manager_code || null;

        if (json && json.membership_start_date) {
            this.membershipStartDate = moment(json.membership_start_date);
        }

        if (json && json.membership_end_date) {
            this.membershipEndDate = moment(json.membership_end_date);
        }

        if (json && json.membership_renewal_date) {
            this.membershipRenewalDate = moment(json.membership_renewal_date);
        }
    }

    id: number;
    appUserID: number;
    membershipStartDate: moment.Moment;
    membershipEndDate: moment.Moment;
    membershipRenewalDate: moment.Moment;
    renewalCount: number;
    inactive: boolean
    firstName: string;
    lastName: string;
    email: string;
    paymentManager: string;
}